/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0 and the Server Side Public License, v 1; you may not use this file except
 * in compliance with, at your election, the Elastic License 2.0 or the Server
 * Side Public License, v 1.
 */

import React, { useContext } from 'react';
import PropTypes from "prop-types";
import { EuiCheckbox } from '../../../form/checkbox';
import { EuiMarkdownContext } from '../../markdown_context';
import { useGeneratedHtmlId } from '../../../../services/accessibility';
export var CheckboxMarkdownRenderer = ({
  position,
  lead,
  label,
  isChecked,
  children
}) => {
  const {
    replaceNode
  } = useContext(EuiMarkdownContext);
  return <EuiCheckbox id={useGeneratedHtmlId()} checked={isChecked} label={children} onChange={() => {
    replaceNode(position, `${lead}[${isChecked ? ' ' : 'x'}]${label}`);
  }} />;
};
CheckboxMarkdownRenderer.propTypes = {
  type: PropTypes.oneOf(["checkboxPlugin"]).isRequired,
  lead: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  isChecked: PropTypes.bool.isRequired,
  position: PropTypes.shape({
    start: PropTypes.shape({
      line: PropTypes.number.isRequired,
      column: PropTypes.number.isRequired,
      offset: PropTypes.number.isRequired
    }).isRequired,
    end: PropTypes.shape({
      line: PropTypes.number.isRequired,
      column: PropTypes.number.isRequired,
      offset: PropTypes.number.isRequired
    }).isRequired
  }).isRequired
};
try {
  CheckboxMarkdownRenderer.__docgenInfo = {
    tags: {},
    filePath: '/app/src/components/markdown_editor/plugins/markdown_checkbox/renderer.tsx',
    description: '',
    displayName: 'CheckboxMarkdownRenderer',
    methods: [],
    props: {
      type: {
        defaultValue: null,
        description: '',
        name: 'type',
        parent: {
          fileName: 'app/src/components/markdown_editor/plugins/markdown_checkbox/types.ts',
          name: 'CheckboxNodeDetails'
        },
        declarations: [{
          fileName: 'app/src/components/markdown_editor/plugins/markdown_checkbox/types.ts',
          name: 'CheckboxNodeDetails'
        }],
        required: true,
        type: {
          name: '"checkboxPlugin"'
        }
      },
      lead: {
        defaultValue: null,
        description: '',
        name: 'lead',
        parent: {
          fileName: 'app/src/components/markdown_editor/plugins/markdown_checkbox/types.ts',
          name: 'CheckboxNodeDetails'
        },
        declarations: [{
          fileName: 'app/src/components/markdown_editor/plugins/markdown_checkbox/types.ts',
          name: 'CheckboxNodeDetails'
        }],
        required: true,
        type: {
          name: 'string'
        }
      },
      label: {
        defaultValue: null,
        description: '',
        name: 'label',
        parent: {
          fileName: 'app/src/components/markdown_editor/plugins/markdown_checkbox/types.ts',
          name: 'CheckboxNodeDetails'
        },
        declarations: [{
          fileName: 'app/src/components/markdown_editor/plugins/markdown_checkbox/types.ts',
          name: 'CheckboxNodeDetails'
        }],
        required: true,
        type: {
          name: 'string'
        }
      },
      isChecked: {
        defaultValue: null,
        description: '',
        name: 'isChecked',
        parent: {
          fileName: 'app/src/components/markdown_editor/plugins/markdown_checkbox/types.ts',
          name: 'CheckboxNodeDetails'
        },
        declarations: [{
          fileName: 'app/src/components/markdown_editor/plugins/markdown_checkbox/types.ts',
          name: 'CheckboxNodeDetails'
        }],
        required: true,
        type: {
          name: 'boolean'
        }
      },
      position: {
        defaultValue: null,
        description: '',
        name: 'position',
        parent: undefined,
        declarations: [{
          fileName: 'app/src/components/markdown_editor/plugins/markdown_checkbox/renderer.tsx',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'EuiMarkdownAstNodePosition'
        }
      }
    },
    extendedInterfaces: ['CheckboxNodeDetails']
  };
} catch (e) {}